import { render, staticRenderFns } from "./Accelerator.vue?vue&type=template&id=47f3cbf0&"
import script from "./Accelerator.vue?vue&type=script&lang=js&"
export * from "./Accelerator.vue?vue&type=script&lang=js&"
import style0 from "./Accelerator.vue?vue&type=style&index=0&id=47f3cbf0&prod&lang=scss&"
import style1 from "./Accelerator.vue?vue&type=style&index=1&id=47f3cbf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports